import React from 'react';
import PropTypes from 'prop-types';
import css from './EmptyState.scss';
import Button from 'Components/Button/Button';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { WEBP_TYPE } from 'Constants/images';
import { compose } from 'redux';
import withConfig from 'HOCs/withConfig/withConfig';
import classnames from 'classnames';
import { CONFIG } from 'Constants/config';

export const EmptyState = props => {
    const showModernDesign = props.config.get(CONFIG.SHOW_MODERN_DESIGN);

    const { isNew } = props;

    return (
        <div
            className={ classnames(css.emptyState, props.className, { [css.addMargin]: isNew }) }
            data-aut-id="emptyState"
        >
            { props.asset
                && <ImageWrapper
                    fileName={ props.asset }
                    types={ WEBP_TYPE }
                    className={ classnames(css.image, { [css.imageNew]: isNew }) }
                    data-aut-id="asset" />
            }
            { props.title
                && <div
                    className={ classnames(css.title, { [css.titleNew]: isNew }) }
                    data-aut-id="title"
                >
                    { props.title }
                </div>
            }
            { props.subTitle
                && <p
                    className={ classnames(css.subTitle, { [css.subTitleLetgo]: showModernDesign, [css.subTitleNew]: isNew }) }
                    data-aut-id="subTitle"
                >
                    { props.subTitle }
                </p>
            }

            { props.buttonText
                && <Button
                    type={ props.buttonType }
                    data-aut-id="emptyStateBtn"
                    onClick={ props.onClick }
                    href={ props.buttonHref }
                    className={ css.button }
                >
                    { props.buttonText }
                </Button>
            }
        </div>
    );
};

EmptyState.propTypes = {
    onClick: PropTypes.func,
    buttonText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    asset: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    subTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    buttonHref: PropTypes.string,
    buttonType: PropTypes.string,
    className: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }),
    isNew: PropTypes.bool
};

EmptyState.defaultProps = {
    onClick: () => {},
    asset: '',
    title: '',
    subTitle: '',
    buttonHref: '',
    buttonType: 'outline',
    className: '',
    config: {
        get: () => {}
    }
};

export default compose(
    withConfig
)(EmptyState);
